import { render, staticRenderFns } from "./StickyOverlay.vue?vue&type=template&id=5d037288&scoped=true"
import script from "./StickyOverlay.vue?vue&type=script&lang=js"
export * from "./StickyOverlay.vue?vue&type=script&lang=js"
import style0 from "./StickyOverlay.vue?vue&type=style&index=0&id=5d037288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d037288",
  null
  
)

export default component.exports